import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absolute top-0 w-full flex justify-between p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-2 w-2 bg-white rounded-full" }, null, -1)
const _hoisted_3 = { class: "text-xs font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute bottom-0 z-10 h-full w-full",
  style: {"background":"linear-gradient(0, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 75%)"}
}, null, -1)
const _hoisted_6 = {
  key: 0,
  style: {"box-shadow":"inset 0 0 0 1000px rgba(0, 0, 0, 0.5)"},
  class: "absolute inset-0 z-10 flex items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center justify-center relative cursor-pointer bg-cover bg-no-repeat bg-center bg-gray-900 rounded-lg overflow-hidden text-white relative", _ctx.hover ? _ctx.hoverClass : '']),
    style: _normalizeStyle(`background-image: url('${_ctx.thumbnailUri}');${
      _ctx.hover ? 'box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.5)' : ''
    }`),
    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hover = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hover = false))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row space-x-3 items-center transition ease-in duration-150", _ctx.hover ? 'opacity-25' : 'opacity-1']),
        style: _normalizeStyle(_ctx.signs.length ? '' : 'visibility: collapse')
      }, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('custom.uhb.scans.sign.number', [_ctx.signs.length])), 1)
      ], 6),
      (_ctx.imageSeries.inadequacies && _ctx.imageSeries.inadequacies.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass([_ctx.hover ? 'opacity-50' : 'opacity-1', "flex items-center py-1.5 px-2 space-x-2 text-black bg-alert-500 rounded mb-2 text-xs font-semibold"])
          }, [
            _createVNode(_component_BaseIcon, { name: "inadequate" }),
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('custom.uhb.scans.inadequate')), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col absolute bottom-0 left-0 z-20 m-6 text-xs font-regular transition ease-in duration-75", _ctx.hover ? 'opacity-25' : 'opacity-1'])
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.description), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.imageSeries.seriesDate)), 1)
    ], 2),
    _createVNode(_component_BaseButton, {
      class: _normalizeClass(["text-white bg-transparent text-sm font-medium z-20 transition duration-150", _ctx.hover ? 'opacity-1 top-0' : 'opacity-0 top-10']),
      "left-icon": "add",
      color: "muted",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.scanHoverMessage), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _hoisted_5,
    (_ctx.loading && !_ctx.hover)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_LoadingIcon)
        ]))
      : _createCommentVNode("", true)
  ], 38))
}